import { Component, ViewChild } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { EnaioCallGetObjectDef } from 'src/modules/enaio/shared/EnaioCallGetObjectDef';
import { EnaioObjectDef } from 'src/modules/enaio/shared/EnaioObjectDef';
import { EnaioObjectId } from 'src/modules/enaio/shared/EnaioObjectId';
import { EnaioObjectTypeId } from 'src/modules/enaio/shared/EnaioObjectTypeId';
import { GenericDataType } from 'src/modules/enaio/shared/GenericDataType';
import { PlotDefinition } from 'src/modules/enaio/shared/PlotDefinition';
import { PlotResult } from 'src/modules/enaio/shared/PlotResult';
import { PlotDefinitionComponent } from 'src/modules/sm-base/components/plot-definition/plot-definition.component';
import { PlotComponent } from 'src/modules/sm-base/components/plot/plot.component';
import { GuiUtils } from 'src/modules/utils/misc/gui-utils';
import { Utils } from 'src/modules/utils/shared/utils';
import { DhTools } from '../../models/dh-tools.model';
import { GenericFieldDefinition } from 'src/modules/sm-base/models/generic-field-definition.model';
import { FrontendFormDefinition } from 'src/modules/sm-base/models/frontend-form-definition.model';
import { FrontendFieldDefinition } from 'src/modules/sm-base/models/frontend-field-definition.model';
import { FrontendFieldType } from 'src/modules/sm-base/models/frontend-field-type.enum';
import { DateInterval } from 'src/modules/utils/shared/date-interval.model';
import { PlotType } from 'src/modules/enaio/shared/PlotType';
import { CalendarOptions } from '@fullcalendar/core';
import resourceTimelinePlugin from '@fullcalendar/resource-timeline';
import { EnaioCallSelect } from 'src/modules/enaio/shared/EnaioCallSelect';
import { EnaioDocument } from 'src/modules/enaio/shared/EnaioDocument';
import { FullCalendarComponent } from '@fullcalendar/angular';

@Component({
  selector: 'app-document-handler-test',
  templateUrl: './document-handler-test.component.html',
  styleUrl: './document-handler-test.component.scss'
})
export class DocumentHandlerTestComponent extends ComponentView {

    form: FrontendFormDefinition;
    def: EnaioObjectDef;
    objectTypeId = new EnaioObjectTypeId(EnaioObjectId.byName("Projekt"), EnaioObjectId.byName("Projekt"));
    @ViewChild("plot")
    plot: PlotComponent;
    @ViewChild("plotDefComponent")
    plotDefComponent: PlotDefinitionComponent;
    plotData: PlotResult;
    plotFields: GenericFieldDefinition[] = [];
    plotTemplates: PlotDefinition[];
    plotDefinition: PlotDefinition;
    showProjects = true;
    showMilestones = true;
    projects: EnaioDocument[];

    @ViewChild("fc") 
    fc: FullCalendarComponent;

    calendarOptions: CalendarOptions = {
        timeZone: 'UTC',
        initialView: 'resourceTimelineYear',
        schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
        plugins: [resourceTimelinePlugin],
       // aspectRatio: 1.5,
        displayEventTime: false,
        eventOverlap: false,
        headerToolbar: {
          left: 'prev,next',
          center: 'title',
          right: 'resourceTimelineDay,resourceTimelineWeek,resourceTimelineMonth,resourceTimelineYear'
        },
        editable: true,
       // resourceAreaHeaderContent: 'Rooms',
        resources: [
          ], 
                    events: [
          ],
          eventMouseEnter: (info) => {
            const tooltipElement = document.createElement('div');
            tooltipElement.innerHTML = info.event._def.title; //extendedProps.description;
            tooltipElement.className = 'custom-tooltip';
            document.body.appendChild(tooltipElement);
    
            const rect = info.el.getBoundingClientRect();
            tooltipElement.style.position = 'absolute';
            tooltipElement.style.top = `${rect.top + window.scrollY - tooltipElement.offsetHeight - 5}px`;
            tooltipElement.style.left = `${rect.left + window.scrollX}px`;
            tooltipElement.style.zIndex = '1000';
    
            (info.el as any)._tooltipElement = tooltipElement;
          },
          eventMouseLeave: (info) => {
            if ((info.el as any)._tooltipElement) {
              document.body.removeChild((info.el as any)._tooltipElement);
              (info.el as any)._tooltipElement = null;
            }
          }
      };

    async initParams(): Promise<boolean> {
        this.form = new FrontendFormDefinition([
            new FrontendFieldDefinition("fromDate", "Startdatum", FrontendFieldType.datePicker, { value: new Date(2023, 0, 1) }),
            new FrontendFieldDefinition("toDate", "Enddatum", FrontendFieldType.datePicker, { value: new Date(2024, 11, 31) })
        ]);
        this.def = await DhTools.enaioCall<EnaioObjectDef>(new EnaioCallGetObjectDef());
        await this.initPlotDefinition();
        return true;
    }


    async initPlotDefinition(): Promise<void> {
        if (this.plotDefinition != null) {
            return;
        }
        this.plotDefinition = new PlotDefinition();
        let otd = this.def.cabinets.find(c => c.name == "Projekt").objectTypes.find(ot => ot.name == "Projekt");
        this.plotFields = otd.getAllFields().map(field => new GenericFieldDefinition(field.name, GenericDataType.string));
        this.plotTemplates = await DhTools.backendCall("api/enaio/plotGetStoredTemplates", { objectTypeId: this.objectTypeId }).list(PlotDefinition);
        GuiUtils.angularTimer(() => this.plotDefComponent.generateForm());
    }

    async generateGantt(): Promise<void> {
        this.projects = await DhTools.enaioCall<EnaioDocument[]>(Utils.fromPlain(EnaioCallSelect, {
            archive: EnaioObjectId.byName("Projekt"),
            objectType: EnaioObjectId.byName("Projekt"),
            fields: EnaioObjectId.byNames(["Projektleiter", "Starttermin", "Endtermin", "Projektname", "Status"])
        }));
        this.updateGantt();
    }

    updateGantt(): void {
        let milestones = [
            { title: "Vorplanung", delta: -120 },
            { title: "Projektplan", delta: -100 },
            { title: "Kalkulation/Mittelfreigabe", delta: -85 },
            { title: "TöB", delta: -75 },
            { title: "Genehmigungen", delta: -60 },
            { title: "Banf-Tiefbau", delta: -20 },
            { title: "Übergabe an Bau", delta: -5 }    
        ];
        let colors = Utils.getMaterialColors();
        let pl = Utils.arrayGetUnique(this.projects.map(p => p.getStringByName("Projektleiter")));
        this.calendarOptions.resources = pl.map(plx => ({ id: plx, title: plx }));
        this.calendarOptions.events = Utils.arrayExplode(this.projects, p => [...this.showProjects ? [{
            id: p.id, 
            resourceId: p.getStringByName("Projektleiter"),
            start: p.getDateByName("Starttermin"),
            end: p.getDateByName("Endtermin"),
            title: p.getStringByName("Projektname"),
            backgroundColor: Utils.toColorHexString(colors[Utils.getStringHash(p.getStringByName("Status")) % colors.length])
        }] : [], ...this.showMilestones ? milestones.map(ms => ({
            id: p.id + "-" + ms.title, 
            resourceId: p.getStringByName("Projektleiter"),
            start: Utils.dateAdd(p.getDateByName("Starttermin"), "day", ms.delta),
            end: Utils.dateAdd(p.getDateByName("Starttermin"), "day", ms.delta),
            title: ms.title + "|" + p.getStringByName("Projektname"),
            backgroundColor: Utils.toColorHexString(colors[Utils.getStringHash(p.getStringByName("Status")) % colors.length])
        })) : []]) as any;

        this.fc.getApi().render();
    }

    async generatePlot(): Promise<void> {
        this.plotData = await DhTools.backendCall("api/enaio/plot", { plotDefinition: this.plotDefComponent.getDefinition(), objectTypeId: this.objectTypeId }).get(PlotResult);
        this.plotData.rows = this.plotData.rows.filter(pd => pd[0] != "0001-01-01T00:00:00" && pd[1] != "0001-01-01T00:00:00" && Utils.arrayGetSafe(pd, 2) != "0001-01-01T00:00:00");
        let dateIntv = new DateInterval(this.form.getValue("fromDate") as Date, this.form.getValue("toDate") as Date);
        if (this.plotDefComponent.getDefinition().type == PlotType.barX) {
            this.plotData.rows = this.plotData.rows.filter(row =>  {
                try {
                    let d1 = new Date(row[0] as string);
                    let d2 = new Date(row[2] as string);
                    console.log(row[0] + " " + row[2]);
                    if (!dateIntv.intersects(new DateInterval(d1, d2))) {
                        return false;
                    }
                    if (d1 < dateIntv.from) {
                        row[0] = dateIntv.from.toISOString();
                    }
                    if (d2 > dateIntv.to) {
                        row[2] = dateIntv.to.toISOString();
                    }
                    return true;
                }
                catch {
                    return true;
                }
            });
        }
        this.plotData.ensureDataTypes();

        this.plot.generate(this.plotDefinition, this.plotData);
    }

    async storePlotTemplate(def: PlotDefinition): Promise<void> {
        await DhTools.backendCall("api/enaio/plotStoreTemplate", { plotDefinition: def, objectTypeId: this.objectTypeId }).getText();
        this.plotTemplates = await DhTools.backendCall("api/enaio/plotGetStoredTemplates", { objectTypeId: this.objectTypeId }).list(PlotDefinition);
        GuiUtils.angularTimer(() => this.plotDefComponent.generateForm());
    }
}
